var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg136(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.45,91.18l14.26-6.63M111.45,62.94l14.26-6.64M94.88,64.16l16.32,7.18m.68,45.37s72.22-26.48-.45-93.58C111.43,23.13,39.61,88.42,111.88,116.71Zm-.45,17.4V26.85m35.48,116.6,17.2-18.52v-24.3s1.25-6.23,6.88-5.92,7.2,4.05,7.2,6.23v33l-24.1,27.72-.31,31.15H125.3V154.21s-1.8-5.8,7.82-16.2c8.1-8.77,23.09-29.39,30.91-19.73M76.41,143.45,59.23,124.93v-24.3S58,94.4,52.34,94.71s-7.2,4.05-7.2,6.23v33l24.1,27.72.31,31.15H98V154.21s1.79-5.8-7.83-16.2c-8.09-8.77-23.08-29.39-30.91-19.73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg136);
export default __webpack_public_path__ + "static/media/_136.9cb4b4396cb77e0853fb335d92ea629c.svg";
export { ForwardRef as ReactComponent };